<dialog #modal class="root-container"
        [ngClass]="{'show-backdrop': showBackDrop}">
    <modal-icon [preset]="iconPreset" [bi_icon]="bi_icon" [type]="iconType"/>
    <div class="title">{{ title }}</div>
    <div class="message">{{ message }}</div>
    <div class="button-container">
        @if (type == 'confirm' || type == 'confirm-warning') {
            <button-component [text]="negative_text"
                              [type]="negativeType"
                              (click)="negativeAction()"/>
        }
        @if (type == 'info' || type == 'confirm') {
            <button-component [text]="positive_text"
                              [type]="positiveType"
                              (click)="positiveAction()"/>
        }
        @if (type == 'confirm-warning') {
            <button-component [text]="positive_text"
                              [type]="warningType"
                              (click)="positiveAction()"/>
        }
    </div>
</dialog>
